<div id="scrn-table">
  <div id="scrn-cell">
    <div id="scrn-p">
      <header id="scrn-h">
        <div class="myunichoices-logo">
          <a routerLink="/login">
            <img src="assets/images/myunichoices-logo.png" alt="" />
          </a>
        </div>
        <div class="subtitle-strap">
          {{ locale.introText }}
        </div>
      </header>
      <form
        id="scrn-c"
        [formGroup]="resetPasswordForm"
        (ngSubmit)="resetPassword(resetPasswordForm.value)"
        novalidate="novalidate"
      >
        <div class="column">
          <div class="form-control">
            <label for="password">{{ locale.passwordPlaceholder }}</label>
            <input
              type="{{ passwordType }}"
              [placeholder]="locale.passwordPlaceholder"
              class="input-control show-pad"
              (keyup)="validate()"
              [formControl]="resetPasswordForm.controls['password']"
            />
            <div
              class="validation-error"
              *ngIf="
                (resetPasswordSubmitted || resetPasswordForm.controls['password'].dirty) &&
                !resetPasswordForm.controls['password'].valid
              "
              [@fadeInOutHeight]
            >
              <div class="form-hint">
                <div>{{ locale.passwordValidationText | stringFormat: [this.passwordLength] }}</div>
              </div>
            </div>
            <span
              ><a (click)="togglePassword()">{{
                showPassword ? locale.hidePasswordText : locale.showPasswordText
              }}</a></span
            >
          </div>
          <div class="form-control">
            <label for="password">{{ locale.confirmNewPasswordPlaceholder }}</label>
            <input
              type="{{ confirmPasswordType }}"
              [placeholder]="locale.confirmNewPasswordPlaceholder"
              class="input-control show-pad"
              validateEqual="password"
              [formControl]="resetPasswordForm.controls['password_confirmation']"
            />
            <div
              class="validation-error"
              *ngIf="
                (resetPasswordSubmitted ||
                  resetPasswordForm.controls['password_confirmation'].dirty) &&
                !resetPasswordForm.controls['password_confirmation'].valid
              "
              [@fadeInOutHeight]
            >
              <div class="form-hint">
                <div>
                  {{
                    locale.confirmNewPasswordValidationText | stringFormat: [this.passwordLength]
                  }}
                </div>
              </div>
            </div>
            <span
              ><a (click)="toggleConfirmPassword()">{{
                showConfirmPassword ? locale.hidePasswordText : locale.showPasswordText
              }}</a></span
            >
          </div>
          <div class="form-control">
            <button type="submit" class="input-control button" [disabled]="formSubmitted">
              {{ locale.resetPasswordButtonText }}
            </button>
          </div>
        </div>
      </form>
      <footer id="scrn-f">
        <div class="sign-up">
          {{ locale.alreadHaveAccountText }} <a routerLink="/login">{{ locale.loginLinkText }}</a>
        </div>
      </footer>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/account/reset-password/reset-password.component.html